import KaoriaoHistoryPage from './KaoriaoHistoryPage';

export default KaoriaoHistoryPage;
